import {
  Error,
  ADD_SALARY,
  UPDATE_SALARY,
  DELETE_SALARY,
  GET_SALARY,
} from "../type";
const initialState = {
  AddSalary: [],
  GetSalary: [],
  UpdateSalary: [],
  DeleteSalary: [],
};
const SalaryR = (state = initialState, action) => {
  switch (action.type) {
    case GET_SALARY:
      return {
        ...state,
        GetSalary: action.payload,
      };

    case ADD_SALARY:
      return {
        GetSalary: state.GetSalary,
        AddSalary: action.payload,
      };
    case UPDATE_SALARY:
      return {
        GetSalary: state.GetSalary,
        UpdateSalary: action.payload,
      };
    case DELETE_SALARY:
      return {
        GetSalary: state.GetSalary,
        DeleteSalary: action.payload,
      };
    case Error:
      return {
        GetSalary: action.payload,
      };
    default:
      return state;
  }
};
export default SalaryR;
